
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-credits",
      function () {
        return require("private-next-pages/travel-credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-credits"])
      });
    }
  